export default {
  x10: 1.0,
  x15: 1.5,
  x20: 2.0
};